'use client'

import { Icon, InputBar } from '@vinted/web-ui'
import { FormEvent, useRef } from 'react'
import { v4 as uuid } from 'uuid'

import { AiSparkles16, Search16 } from '@vinted/monochrome-icons'

import { navigateToPage } from '@marketplace-web/shared/browser-util'
import { cookiesDataByName, useCookie } from '@marketplace-web/environment/cookies-util'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { urlWithParams } from '@marketplace-web/shared/utils'
import { AccessChannel } from 'constants/access-channel'
import { HELP_SEARCH_URL } from 'constants/routes'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

const HelpCenterSearchInputNew = ({ value = '' }) => {
  const translate = useTranslate('help_center')
  const aiPoweredHelpWebAbTest = useAbTest('ai_help_chatbot_web_v1')
  const isAiPoweredHelpWebAbTestEnabled =
    aiPoweredHelpWebAbTest?.variant === 'on_1' || aiPoweredHelpWebAbTest?.variant === 'on_2'
  const searchRef = useRef<HTMLInputElement>(null)
  const cookies = useCookie()

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const searchTerm = searchRef.current?.value

    if (!searchTerm) return
    cookies.set(cookiesDataByName.help_center_search_session_id, uuid())

    navigateToPage(
      urlWithParams(HELP_SEARCH_URL, {
        search_text: searchTerm,
        access_channel: AccessChannel.HcSearch,
      }),
    )
  }

  return (
    <form onSubmit={handleSubmit}>
      <InputBar
        value={value || searchRef.current?.value}
        icon={<Icon name={isAiPoweredHelpWebAbTestEnabled ? AiSparkles16 : Search16} />}
        name="help-center-search"
        placeholder={translate('search_field_placeholder')}
        ref={searchRef}
        data-testId="help-center-new-search-text"
      />
    </form>
  )
}

export default HelpCenterSearchInputNew
